import { render, staticRenderFns } from "./Sims.vue?vue&type=template&id=7c9d1294&"
import script from "./Sims.vue?vue&type=script&lang=ts&"
export * from "./Sims.vue?vue&type=script&lang=ts&"
import style0 from "./Sims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports